let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lKaDG"), load("aBPqh")]).then(() => parcelRequire('6Kkwl'));